import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { datePickerSx } from "lib/muiStyle/muiStyle";
import Label from "../Label/Label";
import HelperMessage from "components/Input/HelperMessage/HelperMessage";
import dayjs from "dayjs";
import c from "lib/style/colorVar.scss";

const Datepicker = ({
  inputRef,
  label,
  subLabel,
  hideLabel = false,
  emptyLabel = false,
  mandatory,
  type,
  errorMessage,
  noErrorMessage,
  onchangeFn,
  onfocusFn,
  onblurFn,
  value,
  limitValue,
  minDate,
  maxDate,
  defaultValue,
  sxParams,
  disabled,
  readOnly,
  divStyle
}) => {
  const { datepickerFocus, datepickerError } = sxParams;
  return (
    <div onFocus={onfocusFn} onBlur={onblurFn} style={divStyle}>
      {!hideLabel && <Label label={label} subLabel={subLabel} mandatory={mandatory} empty={emptyLabel} />}
      <DatePicker
        inputRef={inputRef}
        slotProps={{
          textField: {
            size: "small",
            style: disabled ? { background: c.disabledFieldBg } : {},
          },
        }}
        format="YYYY-MM-DD"
        value={value && dayjs(value)}
        defaultValue={defaultValue}
        onChange={(e) => onchangeFn(e, type)}
        {...(limitValue && {
          [type === "start" ? "maxDate" : "minDate"]: dayjs(limitValue),
        })}
        {...(minDate && {
          minDate,
        })}
        {...(maxDate && {
          maxDate,
        })}
        sx={() => datePickerSx(datepickerFocus, datepickerError)}
        disabled={disabled}
        readOnly={readOnly}
      />
      {!noErrorMessage && (
        <HelperMessage message={datepickerError && errorMessage} />
      )}
    </div>
  );
};

export default React.memo(Datepicker);
